import Masnory from "masonry-layout";
import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import tplWaterfall from "@/home/parts/Tpl/tplWaterfall.vue";
import naturalsort from "javascript-natural-sort";
naturalsort.insensitive = true;
@Component({
    components: {
        tplWaterfall,
    },
})
export default class tplCenter extends Vue {
    masnory: any = {}; //masnory实例
    el = null; //瀑布流根节点
    works = [];
    isAdding = false; //正在加载模板
    offset = 0;
    count = 50;
    updateId = 0; //每次更新作品数据都递增，如果image onload不在自己周期内，不继续添加

    clearWaterfall() {
        this.works = [];
        this.masnory.items = [];
        this.updateId++;
        this.masnory?.layout();
    }
    reOrder(type, order) {
        let works = this.works.sort((a, b) => {
            return order ? naturalsort(a[type], b[type]) : naturalsort(b[type], a[type]);
        });
        this.clearWaterfall();
        this.updateWaterfall({
            works,
            noCache: null,
            callback: null,
        });
    }
    //更新目标瀑布流数据并布局
    updateWaterfall3({ works, noCache, callback }) {
        // 5个并行下载
        if (!works || works.length == 0) return Promise.resolve();
        let resolver = null;
        let updateList = (arr) => {
            let doAdd = (v) => {
                this.works.push(v);
                this.$nextTick(() => {
                    this.masnory?.layout();
                    this.masnory.appended(this.el.lastChild);
                });
            };
            let sequence = Promise.resolve();
            arr.forEach(function (item) {
                if (item)
                    sequence = sequence.then((e) => {
                        return doAdd(item);
                    });
            });
            sequence.then((e) => {
                console.log("ok");
            });
        };

        let createAddworkFunc = (updateId) => {
            //把当前updateId包一下
            let step = 5;
            let addWork = (i) => {
                if (i == works.length - 1) {
                    resolver();
                    if (callback) callback();
                }
                let len = i + step > works.length ? works.length : i + step;
                let pList = [];
                for (let j = i; j < len; j++) {
                    let item = works[j];
                    if (!item.author) {
                        item.author = "";
                    }
                    let imgEle = document.createElement("img");
                    pList.push(
                        new Promise((rs, rj) => {
                            imgEle.onload = () => {
                                if (updateId != this.updateId) return;
                                rs(item);
                                if (j == works.length - 1) return;
                            };
                            imgEle.onerror = () => {
                                if (j == works.length - 1) return;
                                rs();
                            };
                            let thumbSrc = window["GLOBAL"].PUBLIC_OSS_HOST + item.url + "thumb.png";
                            if (noCache) {
                                //禁止缓存
                                thumbSrc = thumbSrc + "?timestamp=" + new Date().getTime();
                                item.thumbSrc = thumbSrc;
                            }
                            // noCache
                            imgEle.setAttribute("src", thumbSrc);
                        })
                    );
                }
                if (pList.length > 0) {
                    Promise.all(pList).then((e) => {
                        console.log("data", e);
                        updateList(e);
                        addWork(len);
                    });
                }
            };
            return addWork;
        };
        this.updateId++;
        let addWork = createAddworkFunc(this.updateId);

        let prm = new Promise((resolve) => {
            resolver = resolve;
            this.$nextTick(() => {
                this.masnory?.layout();
                addWork(0);
            });
        });
        prm.then(() => {
            console.log("asdasd");
            this.masnory?.layout();
        });
        return prm;
    }
    updateWaterfall({ works, noCache, callback }, isCenter: boolean = false) {
        if (!works || works.length == 0) return Promise.resolve();
        let resolver = null;
        let createAddworkFunc = (updateId) => {
            //把当前updateId包一下
            let addWork = (i) => {
                let item = works[i];
                if (!item.author) {
                    item.author = "";
                }
                let imgEle = document.createElement("img");
                // if (i && i == works.length - 1) {
                //     resolver();
                //     if (callback) callback();
                // }
                imgEle.onload = () => {
                    if (updateId != this.updateId) return;
                    this.works.push(item);
                    this.$nextTick(() => {
                        if (!this.masnory) {
                            resolver();
                            return;
                        }
                        this.masnory.layout();
                        this.masnory.appended(this.el.lastChild);
                        // works.length == 1 && resolver();
                        if (i == works.length - 1) {
                            resolver();
                            if (callback) callback();
                        }
                    });
                    // if (i == works.length - 1) return;
                    // addWork(i + 1);
                    if (i != works.length - 1) {
                        addWork(i + 1);
                    }
                };
                imgEle.onerror = () => {
                    console.log(i);
                    if (!this.masnory) {
                        resolver();
                        return;
                    }
                    if (i != works.length - 1) {
                        addWork(i + 1);
                    } else {
                        resolver();
                        if (callback) callback();
                    }
                };
                let thumbSrc = window["GLOBAL"].PUBLIC_OSS_HOST + item.url + "thumb.png";
                if (noCache) {
                    //禁止缓存
                    thumbSrc = thumbSrc + "?timestamp=" + new Date().getTime();
                    item.thumbSrc = thumbSrc;
                }

                // noCache
                imgEle.setAttribute("src", thumbSrc);
            };
            return addWork;
        };
        let createAddworkFuncEn = (updateId) => {
            //把当前updateId包一下
            let addWork = (i) => {
                let item = works[i];
                if (!item.author) {
                    item.author = "";
                }
                if (updateId != this.updateId) return;

                let thumbSrc = window["GLOBAL"].PUBLIC_OSS_HOST + item.url + "thumb.png";
                if (noCache) {
                    //禁止缓存
                    thumbSrc = thumbSrc + "?timestamp=" + new Date().getTime();
                    item.thumbSrc = thumbSrc;
                }
                this.works.push(item);
                this.$nextTick(() => {
                    if (!this.masnory) {
                        resolver();
                        return;
                    }
                    this.masnory?.layout();
                    this.masnory.appended(this.el.lastChild);
                    // works.length == 1 && resolver();
                    if (i == works.length - 1) {
                        resolver();
                        if (callback) callback();
                    }
                    if (i != works.length - 1) {
                        addWork(i + 1);
                    }
                });
            };
            return addWork;
        };
        if (isCenter) {
            this.masnory.appended(document.getElementById("AddNewTemp"));
        }
        this.updateId++;
        let addWork = this.internal ? createAddworkFunc(this.updateId) : createAddworkFuncEn(this.updateId);

        let prm = new Promise((resolve) => {
            resolver = resolve;
            this.$nextTick(() => {
                this.masnory?.layout();
                addWork(0);
            });
        });
        prm.then(() => {
            setTimeout(() => {
                this.masnory?.layout();
            }, 300);
        });
        return prm;
    }
    updateWaterfall223({ works, noCache, callback }, isCenter: boolean = false) {
        if (!works || works.length == 0) return Promise.resolve();
        let resolver = null;
        let createAddworkFunc = (updateId) => {
            //把当前updateId包一下
            let addWork = (i) => {
                console.log(updateId);

                let item = works[i];

                if (!item.author) {
                    item.author = "";
                }

                if (!item.author) {
                    item.author = "";
                }

                let thumbSrc = window["GLOBAL"].PUBLIC_OSS_HOST + item.url + "thumb.png";
                if (noCache) {
                    //禁止缓存
                    thumbSrc = thumbSrc + "?timestamp=" + new Date().getTime();
                    item.thumbSrc = thumbSrc;
                }

                this.works.push(item);
                this.$nextTick(() => {
                    let domList = document.getElementsByClassName("mo-work--img");
                    let imgEle = domList[i] as HTMLImageElement;

                    imgEle.onload = () => {
                        console.log(updateId, this.updateId);
                        if (updateId != this.updateId) return;
                        (<HTMLElement>imgEle.parentNode.parentNode.parentNode).style.visibility = null;
                        this.masnory?.layout();
                        this.masnory.appended(this.el.lastChild);
                        if (i == works.length - 1) {
                            resolver();
                            if (callback) callback();
                            return;
                        }
                        addWork(i + 1);
                    };

                    imgEle.onerror = () => {
                        console.log(i);
                        if (i == works.length - 1) {
                            resolver();
                            if (callback) callback();
                            return;
                        }
                        addWork(i + 1);
                    };
                });
            };
            return addWork;
        };
        if (isCenter) {
            this.masnory.appended(document.getElementById("AddNewTemp"));
        }
        this.updateId++;
        let addWork = createAddworkFunc(this.updateId);

        let prm = new Promise((resolve) => {
            resolver = resolve;
            this.$nextTick(() => {
                this.masnory?.layout();
                addWork(0);
            });
        });
        prm.then(() => {
            this.masnory?.layout();
        });
        return prm;
    }
    mounted() {
        console.log("come on mounted");
        this.el = (<any>this.$refs.waterfall).$el;
        //瀑布流
        this.masnory = new Masnory(this.el, {
            // options
            itemSelector: ".mo-work",
            columnWidth: ".mo-waterfall--grid-sizer",
            gutter: ".mo-waterfall--gutter-sizer",
            transitionDuration: "0.45s",
            hiddenStyle: {
                transform: "translateY(-30px)",
                opacity: 0,
            },
            visibleStyle: {
                transform: "translateY(0px)",
                opacity: 1,
            },
        });
    }
    beforeDestroy() {
        this.masnory = null;
        this.el = null;
    }
}
